export default "__VITE_ASSET__$PPKAOTO__"